import React, { Fragment, useRef, useState } from "react";
import useMeasure from "react-use-measure";
import { mergeRefs } from "react-merge-refs";
import { useAppContext } from "../helpers/account-context";

import { toPermalink } from "../helpers/helper";
import { HeroResult } from "./Components/HeroInfo";
import { CtaResult } from "./Components/CtaInfo";
import { TagsResult } from "./Components/TagsInfo";
import { HoursResult } from "./Components/HoursInfo";
import { FieldsResult } from "./Components/FieldsInfo";
import { CustomFieldsResult } from "./Components/CustomFieldsInfo";
import { HorizonalLine } from "./Components/Mixin";
import { SocialsResult } from "./Components/SocialsInfo";
import { DistanceResult } from "./Components/DistanceInfo";
import { DirectionResult } from "./Components/DirectionInfo";
import { ViewDetailsResult } from "./Components/ViewDetailsInfo";

const defaultFields = [
]

const ResultPropRow = (props) => {
  const { fieldName, currentGeo } = props;

  if (fieldName === "name" || fieldName === "location_type_name")
    return <FieldsResult {...props} fieldName={fieldName} hiddenLabel={true} />;

  if (fieldName === "hours") return <HoursResult {...props} />;
  if (fieldName === "cta_buttons") return <CtaResult {...props} />;
  if (fieldName === "tags") return <TagsResult {...props} />;
  if (fieldName === "custom_fields") return <CustomFieldsResult {...props} />;
  if (fieldName === "distance") return <DistanceResult {...props} geopos={currentGeo} />
  if (fieldName === "socials") return <SocialsResult {...props}/>
  if (fieldName === "directions") return <DirectionResult {...props}/>
  if (fieldName === "view_details") return <ViewDetailsResult {...props}/>
  if (fieldName && !!fieldName.match(/hr\d{1}/i)) return <HorizonalLine {...props}/>

  return <FieldsResult {...props} fieldName={fieldName} hiddenLabel={true} />;
};

const ResultRow = (props) => {
  const { account } = useAppContext();
  const {
    item,
    selectedItem,
    hoveredItem,
    onSelectItem,
    onHoverItem,
  } = props;
  
  const { card_result = {} } = account;
  const fields = card_result && card_result.fields ? card_result.fields : defaultFields;
  const fieldsList = fields.map((fieldName) => (
    <ResultPropRow
      key={toPermalink(fieldName)}
      {...props}
      fieldName={fieldName}
    />
  ))
  return (
    <div
      className={`cbmap-item cbmap-item_${toPermalink(item.properties.name)} ${
        item.properties.uid === selectedItem?.properties.uid ? "is-selected" : ""
      } ${item.properties.uid === hoveredItem?.properties.uid ? "hovering" : ""}`}
      key={item.properties.uid}
      onClick={(e) => onSelectItem(item)}
      onMouseEnter={(e) => onHoverItem(item)}
      onMouseLeave={(e) => onHoverItem(null)}
    >
      <div className={`cbmap-item-inner cbmap-hero-pos_${card_result.hero_position}`}>
        {
          (!!card_result.hero_position && card_result.hero_position !== 'hidden') && <HeroResult
          fieldName="hero"
          {...props}
          />
        }
        <div className="cbmap-item-props">
          {fieldsList}
        </div>
      </div>
    </div>
  );
};


export const ListResults = (props) => {
  const {getLocale} = useAppContext();
  const [isShowingScroller, setIsShowingScroller] = useState(false)
  const { showListing, points, selectedLocation, hoveredLocation , handleSelectLocation, handleHoverLocation} = props;
  const resultsRef = useRef();
  const itemsRef = useRef();
  const [containerRef, containerBounds] = useMeasure();
  const [innerRef, innerBounds] = useMeasure();

  const isScrollable =
    containerBounds &&
    innerBounds &&
    containerBounds.height < itemsRef.current?.scrollHeight;
  const innerSearchEle = document.querySelector('.cbmap-search-inner.cbmap-visible');
  const styles = {};
  if (points.length === 0) return null;
  
  if (innerSearchEle) {
    styles.height = `calc(100% - ${innerSearchEle.offsetHeight}px)`;
  }
  const handleScrollTop = (e) => {
    e.preventDefault();   
    if (resultsRef.current) {
      itemsRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      })
    }
  }
  const handleOnScroll = (e) => {
    setIsShowingScroller(e.target.scrollTop > containerBounds.height)
  }

  return (

          <Fragment>
          <div 
            ref={mergeRefs([resultsRef, containerRef])}
            style={styles}
            onScroll={handleOnScroll}
            className={`cbmap-results cbmap-scrollable ${
            showListing
              ? "cbmap-visible"
              : "cbmap-hidden"
            }
            ${
              isScrollable ? 'cbmap-overheight' : ''
            }
          `}          
        >
            <div className="cbmap-list-items" ref={mergeRefs([itemsRef, innerRef])}>
              {points.map((item, idx) => (
                <ResultRow
                  key={`result-row-${idx}-${item.properties.uid}`}
                  item={item}
                  selectedItem={selectedLocation}
                  hoveredItem={hoveredLocation}
                  onSelectItem={handleSelectLocation}
                  onHoverItem={handleHoverLocation}
                  currentGeo={props.currentGeo}
                />
              ))}
            </div>
        </div>    
        {
          isScrollable && isShowingScroller && <div className="cbmap-btn-gotop" 
          title={getLocale('scroll_to_top')}
          onClick={handleScrollTop}
        >
          &uarr;
        </div>
        }
        
        </Fragment>

  )
}
